import { render, staticRenderFns } from "./slots.vue?vue&type=template&id=0371af1e"
import script from "./slots.vue?vue&type=script&lang=js"
export * from "./slots.vue?vue&type=script&lang=js"
import style0 from "./slots.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/slots/slots.vue
// module id = 4Set
// module chunks = 0